<template>
  <el-menu
    :default-active="activedRoute"
    :unique-opened="true"
    :active-text-color="$store.state.app.themeColor"
    :router="true"
  >
    <!-- <el-menu-item style="padding-left: 20px; background: #009688" index="xz">
      <i class="el-icon-circle-plus-outline"></i>
      新增
    </el-menu-item> -->
    <template v-for="item in menus">
      <el-submenu v-if="item.hidden" :key="item.path" :index="item.path">
        <template slot="title">
          <i :class="item.icon" id="iconStyle"></i>
          <span class="menu-title">{{ item.name }}</span>
        </template>

        <el-menu-item-group v-if="item.children">
          <el-menu-item
            v-for="i in item.children"
            :key="i.path"
            :index="i.path"
            >{{ i.name }}</el-menu-item
          >
        </el-menu-item-group>
      </el-submenu>
    </template>
  </el-menu>
 
</template>

<script>
import { getSession } from "@/utils/session";
export default {
  name: "Aside",
  data() {
    return {
      // activedRoute: "/expand/list",
      activedRoute: "",
      menus: getSession("menu") || [],
    };
  },
  mounted() {
    this.menus = this.$router.options.routes;
    // let menus = this.$store.state.app.menu;
    // if (this.menus.length !== 0) {
    //   if (this.menus[0].children.length !== 0) {
    //     this.activedRoute = this.menus[0].children[0].path;
    //   } else {
    //     this.activedRoute = this.menus[0].path;
    //   }
    // }
    // this.$nextTick(() => {
    //   this.$router.push(this.activedRoute || "/login");
    // });
    // this.activedRoute = this.$route.fullPath;
  },
  methods: {
    /*菜单栏切换*/
    handleSelect(key, keyPath) {
      this.$router.push("/" + key);
    },
  },
};
</script>

<style lang="scss" scoped>
.menu-title {
  font-weight: 900;
}
.el-submenu{
  margin: 20px 0 !important;
}
</style>